import React from "react";
import { useTranslation } from "react-i18next";

import Review from "./components/Review";

import { reviewsData } from "./utils/reviews";

import classes from "./index.module.css";

const Reviews = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["wrapper"]}>
      <h3 className={classes["title"]}>{t("Reviews")}</h3>
      <div className={classes["reviews-wrapper"]}>
        {reviewsData.map((review) => {
          return <Review review={review} />;
        })}
      </div>
    </div>
  );
};

export default Reviews;
